export var tryParseInt = function (value, defaultValue) {
    var result = { hasValue: false, value: defaultValue !== null && defaultValue !== void 0 ? defaultValue : 0 };
    if (value == null)
        return result;
    var parseValue = value.toString();
    if (parseValue.length < 1)
        return result;
    result.value = parseInt(parseValue);
    result.hasValue = result.value >= 0;
    return result;
};
export var tryParseFloat = function (value, defaultValue) {
    var result = { hasValue: false, value: defaultValue !== null && defaultValue !== void 0 ? defaultValue : 0 };
    if (value == null)
        return result;
    var parseValue = value.toString();
    if (parseValue.length < 1)
        return result;
    result.value = parseFloat(parseValue);
    result.hasValue = result.value >= 0;
    return result;
};
export var tryParseNumber = function (value, defaultValue) {
    var _a;
    if (value == null)
        return defaultValue !== null && defaultValue !== void 0 ? defaultValue : 0;
    var parseValue = (_a = value.toString()) !== null && _a !== void 0 ? _a : '';
    while (parseValue.includes(',')) {
        parseValue = parseValue.replace(',', '');
    }
    return tryParseFloat(parseValue, defaultValue).value;
};
export var isInt = function (value) {
    return !isNaN(parseInt(value));
};
